/** Display label from internal level code (Form1 → Form 1). */
export function formatLevelLabel(code) {
    return String(code || "")
        .replace(/^Form(\d)$/i, "Form $1")
        .replace(/^Std(\d)$/i, "Std $1")
        .replace(/^Year(\d)$/i, "Year $1");
}

/** Build class name shown in lists (e.g. Form 1 + A → "Form 1 A"). */
export function buildClassDisplayName(levelCode, stream) {
    const display = formatLevelLabel(levelCode);
    const section = String(stream || "").trim();
    return section ? `${display} ${section}` : display;
}

/**
 * Parse "A, B" or "A;B" into ["A","B"]. Empty input → one class with no section suffix.
 */
export function parseStreamsInput(raw) {
    const text = String(raw || "").trim();
    if (!text) return [""];

    const parts = text
        .split(/[,;|/]+/)
        .map((s) => s.trim())
        .filter(Boolean);

    const seen = new Set();
    const out = [];
    for (const part of parts) {
        const label = normalizeStreamLabel(part);
        const key = label.toLowerCase();
        if (!seen.has(key)) {
            seen.add(key);
            out.push(label);
        }
    }
    return out.length ? out : [""];
}

function normalizeStreamLabel(value) {
    const t = String(value || "").trim();
    if (/^[a-z]$/i.test(t)) return t.toUpperCase();
    return t;
}

/** Preview class names for UI before submit. */
export function previewClassNames(levelCodes, streamsInput) {
    const streams = parseStreamsInput(streamsInput);
    const codes = Array.isArray(levelCodes) ? levelCodes : [levelCodes].filter(Boolean);
    const names = [];
    for (const code of codes) {
        for (const stream of streams) {
            names.push(buildClassDisplayName(code, stream));
        }
    }
    return names;
}

export const QUICK_SECTION_OPTIONS = ["A", "B", "C", "D", "East", "West", "Science", "Arts"];
